<template>
	<div class="pa-2">
		<b-search
			v-model="search"
			class="mb-1"
			:bones="searchItems"
			@search="fetch()"
			@clear="
				fetch();
				searchType = attendanceType.all.value;
			">
			<template>
				<div class="d-flex flex-wrap">
					<v-btn-toggle
						class="me-2 mt-1"
						color="primary"
						mandatory
						v-model="searchType"
						@change="fetch()"
						dense>
						<v-btn :value="attendanceType.all.value">
							{{ attendanceType.all.text }}
						</v-btn>
						<v-btn :value="attendanceType.committed.value">
							{{ attendanceType.committed.text }}
						</v-btn>
						<v-btn :value="attendanceType.late.value">
							{{ attendanceType.late.text }}
						</v-btn>
						<v-btn :value="attendanceType.earlyLeave.value">
							{{ attendanceType.earlyLeave.text }}
						</v-btn>
						<v-btn :value="attendanceType.absence.value">
							{{ attendanceType.absence.text }}
						</v-btn>
					</v-btn-toggle>


					<v-btn-toggle
						v-model.number="sort"
						mandatory
						dense
						class="mt-1"
						color="primary"
						@change="fetch()"
                	>
						<v-btn :value="1" :disabled="Boolean(loadingFingerprint)">الترتيب حسب الكود</v-btn>
						<v-btn :value="2" :disabled="Boolean(loadingFingerprint)">الترتيب حسب وقت التأخير </v-btn>
						<v-btn :value="3" :disabled="Boolean(loadingFingerprint)">ترتيب حسب الانصراف المبكر</v-btn>
						<v-btn :value="4" :disabled="Boolean(loadingFingerprint)">ترتيب حسب العمل الإضافي</v-btn>
                	</v-btn-toggle>

					<v-checkbox
						v-model="notValid"
						@change="fetch()"
						label="البصمات الفردية"
						dense
						hide-details></v-checkbox>
					<!-- <v-radio-group
						v-model="searchType"
						mandatory
						class="mt-0"
						dense
						row
						hide-details>
						<v-radio
							:label="attendanceType.all.text"
							:value="attendanceType.all.value"></v-radio>
						<v-radio
							:label="attendanceType.committed.text"
							:value="attendanceType.committed.value"></v-radio>
						<v-radio
							:label="attendanceType.late.text"
							:value="attendanceType.late.value"></v-radio>
						<v-radio
							:label="attendanceType.earlyLeave.text"
							:value="attendanceType.earlyLeave.value"></v-radio>
						<v-radio
							:label="attendanceType.absence.text"
							:value="attendanceType.absence.value"></v-radio>
					</v-radio-group> -->
					<!-- <v-spacer /> -->
					<!--  -->
					<v-checkbox
						v-model="checked"
						hide-details
						:label="$t('WorkAttendance.checked')"
						@change="changeStatusAtte()"
						dense
						:disabled="(search.toggle?.length === 2) || (search.toggle?.length === 1 && search.NameOrCode) || (search.toggle?.length === 1 && search.SectionId)"
					/>
				
				</div>
			</template>

			<template #end>
				<div class="d-flex flex-column ">
					<v-btn
						@click="showDialog = true"
						color="primary"
						small
					>
						<v-icon
							size="20"
							left
						>
							$add
						</v-icon>
						{{ $T('add') }}
					</v-btn>
					<v-btn @click="exportFile()" :loading="excelLoading" class="mx-1 mt-1" small color="success">
						<v-icon small class="pe-1"> mdi-export </v-icon>
						تصدير لإكسل
					</v-btn>
				</div>
			</template>
		</b-search>

		<customizable-table
			:headers="headers"
			localStorageName="attendance.work">
			<template v-slot:default="{ headers, openCustomizer }">
				<bee-handy-table
					ref="table"
					:headers="headers"
					:items="[]"
					:data-table-props="{ disableSort: true }"
					dense
					zebra
					fixed-header
					:row-highlight-expression="(e) => !e.arrivalTime || !e.departureTime"
					:row-highlight-expression-class="'is-absent-row'"
					:height="$vuetify.breakpoint.height - 210"
					pagination-on-scroll
					pagination-on-scroll-server-items
					:pagination-on-scroll-loading="loading"
					:server-items-length="Number(itemsCount)"
					:items-per-page="30"
					:options-scroll.sync="scrollOptions"
					hide-default-footer
					@pagination-on-scroll:reach-last-row="fetch">
					<template v-slot:item.type="{ item }">
						<v-icon
							small
							v-if="item.type === addingAttendanceTypeEnum.fingerPrints">
							mdi-fingerprint
						</v-icon>
						<v-badge
							v-if="item.type === addingAttendanceTypeEnum.fingerPrintsEdited"
							color="grey--text"
							icon="$edit"
							overlap
							left
							bottom>
							<v-icon small> mdi-fingerprint </v-icon>
						</v-badge>
						<v-icon
							small
							v-if="item.type === addingAttendanceTypeEnum.dialog">
							mdi-server-outline
						</v-icon>
						<v-badge
							v-if="item.type === addingAttendanceTypeEnum.dialogEdited"
							color="grey--text"
							icon="$edit"
							overlap
							left
							bottom>
							<v-icon small> mdi-server-outline </v-icon>
						</v-badge>
					</template>

					<template v-slot:item.actions="{ item }">
						<div class="d-flex">
							<tooltip :text="$T('tooltips.employee')">
								<v-btn
									:to="{
										name: 'personal-info',
										query: { employeeId: item.employeeId },
									}"
									small
									icon>
									<v-icon
										size="20"
										color="preview">
										$viewEmployee
									</v-icon>
								</v-btn>
							</tooltip>
							<tooltip :text="$T('tooltips.showFinderPrints')">
								<v-btn
									:loading="loadingFingerprint === item.id"
									:disabled="!!loadingFingerprint"
									small
									icon
									@click="fetchFingerprints(item)">
									<v-icon
										size="20"
										color="preview">
										mdi-fingerprint
									</v-icon>
								</v-btn>
							</tooltip>
						</div>
					</template>
					<template v-slot:top="{}">
						<v-btn
							style="z-index: 3"
							class="me-n2"
							left
							absolute
							@click="openCustomizer"
							x-small
							depressed>
							تعديل
						</v-btn>
					</template>
				</bee-handy-table>
			</template>
		</customizable-table>

		<!-- add work dialog -->
		<v-dialog
			v-model="showDialog"
			max-width="400px"
			transition="dialog-transition">
			<b-add-work-day
				@close="showDialog = false"
				@done="fetch()"
			></b-add-work-day>
		</v-dialog>

		<!-- fingerprint dialog -->
		<v-dialog
			v-model="showFingerprintDialog"
			max-width="600px"
			transition="dialog-transition">
			<b-fingerprint-dialog
				:loading-fetch="loadingFingerprint"
				:id="showFingerprintDialog"
				:data="fingerprints"
				:details="fingerprintDetails"
				@close="showFingerprintDialog = null"
				@re-fetch="fetchFingerprints"></b-fingerprint-dialog>
		</v-dialog>
	</div>
</template>

<script>
import attendance from './attendance';
import BAddWorkDay from '@/components/forms/BAddWorkDay.vue';
import BFingerprintDialog from '@/components/forms/BFingerprintDialog.vue';
import { diff } from '@/utils/moment';
import { attendanceType } from '@/utils/enum';
import { nextTick } from 'vue';
import moment from 'moment';
import { mapState } from 'vuex'

const addingAttendanceTypeEnum = {
	fingerPrints: 0,
	fingerPrintsEdited: 1,
	dialog: 2,
	dialogEdited: 3,
};

export default {
	name: 'WorkAttendance',

	mixins: [attendance],

	components: { BAddWorkDay, BFingerprintDialog },

	data() {
		return {
			searchItems: [
				{
					type: 'name',
					value: 'NameOrCode',
				},
				{
					type: 'section',
					value: 'SectionId',
				},
				{
					type: 'type',
					value: 'type',
				},
				{
					type: 'toggle',
					value: 'toggle',
					items: [
						{
							name: 'مدة',
							for: ['DateTo', 'DateFrom'],
						},
						{
							name: 'يومي',
							for: ['Date'],
						},
					],
				},
				{
					type: 'from_date',
					value: 'DateFrom',
					toggle: 'toggle',
				},
				{
					type: 'to_date',
					value: 'DateTo',
					toggle: 'toggle',
				},
				{
					type: 'switch_date',
					value: 'Date',
					toggle: 'toggle',
					valuesAs: ['DateFrom', 'DateTo'],
				},
			],

			loadingFingerprint: null,
			showFingerprintDialog: false,
			fingerprints: null,
			fingerprintDetails: null,

			storeModel: 'attendance/fetchAttendance',

			notValid: null,
			searchType: null,

			search: {},
			storeParameter: {},
			attendanceType,
			addingAttendanceTypeEnum,

			fingerprintFile: null,
			loadingAddingFingerprint: false,
			sort: 0,
			checked: false,
			workDayId: null,
			excelLoading: false
		};
	},

	watch: {
		search: {
			handler(newVal) {
				this.storeParameter = { ...newVal, AttendType: this.attendanceType,
					OrderByCode: this.sort===0, 
					OrderByLate: this.sort === 1,
					OrderByEarlyLeave: this.sort === 2, 
					OrderByOverTime: this.sort === 3 
				};
			},
			deep: true,
		},

		// workDayId(val) {
		// 	this.$store.dispatch('attendanceSystem/fetchStatusAtt', { id: val }).then((data) => {
		// 		this.checked =  data
		// 	})
		// }
	},

	computed: {
		...mapState({
			sections: (state) => state.section.sections,
		}),
		headers() {
			return [
				{
					text: this.$T('headers.code'),
					value: 'employeeBrief.code',
					name: 'code',
					cellClass: '',
				},
				{ text: '', value: 'type', name: 'type', sortable: false, width: 0, cellClass: 'pe-0 ps-2' },
				{
					text: this.$T('headers.employee-name'),
					value: 'name',
					name: 'employee',
					cellClass: 'ps-0',
				},
				{ 
					text: this.$T('headers.section-name'), 
					value: 'section', 	
					setValueExpr: (v) => {
						if (!this.sections || !this.sections.length) return null;

						return this.sections.find((e) => e.id === v)?.name;
					},  
					name: 'section' 
				},
				{
					text: this.$T('headers.date'),
					type: 'date',
					// dateFormat: DATE_FORMAT,
					value: 'date',
					name: 'date',
					setValueExpr: val => moment(val).format('YYYY-MM-DD')
				},
				{
					text: this.$T('headers.attendance.firstFinderPrint'),
					value: 'arrivalTime',
					name: 'startTime',
					noNotAvailableText: false,
					setValueExpr: (value, index) =>
						moment(value).isValid() ? moment(value).format('hh:mm A') : '-',
				},
				{
					text: this.$T('headers.attendance.lastFinderPrint'),
					value: 'departureTime',
					name: 'endTime',
					setValueExpr: (value, index) =>
						moment(value).isValid() ? moment(value).format('hh:mm A') : '-',
				},
				{
					text: this.$T('headers.attendance.duration'),
					value: 'duration',
					name: 'duration',
				},
				{
					text: this.$T('headers.attendance.delay'),
					value: 'delayArrivalInMinute',
					name: 'delay',
				},
				{
					text: this.$T('headers.attendance.earlyLeave'),
					value: 'earlyGoInMinute',
					name: 'earlyLeave',
				},
				{
					text: this.$T('headers.attendance.extraTotal'),
					value: 'overTimeInMinute',
					name: 'extra',
				},

				{
					text: this.$T('headers.attendance.fingerPrintCount'),
					value: 'fingerPrintCount',
					name: 'fingerPrintCount',
				},
				{
					text: this.$T('headers.attendance.unjustifiedTime'),
					value: 'unjustifiedTime',
					name: 'unjustifiedTime',
				},
				{
					text: this.$T('headers.attendance.durationToAll'),
					value: 'durationToAll',
					name: 'durationToAll',
				},
				{
					text: this.$T('headers.attendance.earlyLeaveToVacation'),
					value: 'earlyLeaveToVacation',
					name: 'earlyLeaveToVacation',
				},
				{
					text: this.$T('headers.attendance.lateArriveFromVacation'),
					value: 'lateArriveFromVacation',
					name: 'lateArriveFromVacation',
				},
				{
					text: this.$T('headers.attendance.vacationOverTime'),
					value: 'vacationOverTime',
					name: 'vacationOverTime',
				},
				{
					text: this.$T('headers.attendance.extraBefore'),
					value: 'extraBefore',
					name: 'extraBefore',
				},
				{
					text: this.$T('headers.attendance.extraAfter'),
					value: 'extraAfter',
					name: 'extraAfter',
				},
				{
					text: this.$T('headers.attendance.extraVacation'),
					value: 'extraVacation',
					name: 'extraVacation',
				},
			]
		} 
	},

	methods: {
		fetchFingerprints(item) {
			this.loadingFingerprint = item.id;
			const x = this.items.find((e) => e.id === item.id);
			this.$store
				.dispatch('attendance/getFingerprint', {
					date: x.date,
					employeeCode: x.code,
				})
				.then((res) => {
					this.fingerprints = res;
					this.fingerprintDetails = {
						id: item.id,
						employeeId: item.employeeId,
						name: item.name,
						date: item.date,
					};
					this.showFingerprintDialog = true;
				})
				.finally(() => {
					this.loadingFingerprint = null;
				});
		},
		diff,
		changeStatusAtte() {
			this.loadingFingerprint = true
			this.$store.dispatch('attendanceSystem/updateStatus', { id: this.workDayId }).finally(() => {
				this.loadingFingerprint = false
			})
		},
		exportFile() {
			this.excelLoading = true
			this.$store.dispatch('reports/fetchExcelAttn', {
				dateFrom : this.search.DateFrom,
				dateTo: this.search.DateTo,
				AttendType: this.searchType,
				NameOrNum: this.search.NameOrCode, 
				OrderByCode: this.sort === 1,
				OrderByLate: this.sort ===  2,
				OrderByEarlyLeave: this.sort === 3,
				OrderByOverTime: this.sort === 4,
				Valid: this.notValid ? false : null,
				SectionId: this.search.SectionId, 			
			}).finally(() => {
				this.excelLoading = false
			})
		}
	},

	mounted() {
		this.storeParameter = {
			...this.search,
			AttendType: this.attendanceType,
		};
		this.$refs.table.resetShownRows()
		nextTick(() => {
			// this.fetch()
			// .then(() => {
				// if(this.workDayId) {
				// 	this.$store.dispatch('attendanceSystem/fetchStatusAtt', { id: this.workDayId }).then((data) => {
				// 	this.checked =  data.data
				// 	console.log('this.checked')
				// 	console.log(this.checked)
				// })}
			// });
		});
	}
};
</script>

<style lang="scss" scoped></style>
